import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import LineChart from "../../components/LineChart";
import SelectLabels from "../../components/SelectLabels";

function DashboardSalesTrend() {
  const { createData } = SupervisorApi();
  const [newPeriod] = useState({ data_filter: "7days" });
  const [dataSet, setDataset] = useState({});

  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  const defaultNum = 0;

  // useEffect(() => {
  //   setNewPeriod(period[timeRange].key);
  // }, [timeRange]);

  const chartData = useMutation({
    mutationFn: (newPeriod) =>
      createData(`dashboard/sales-trend?date_filter=${newPeriod}`, null, true),
    onSuccess: (data) => {
      console.log(data);
      setDataset(data?.data);
    },
  });
  const handleChange = (value) => {
    const key = Object.values(period).find((item) => item.id === value)?.key;
    chartData.mutate(key);
  };
  useEffect(() => {
    chartData.mutate(newPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-6">
      <div className="flex justify-between">
        {" "}
        <h3 className="text-3xl font-semibold mb-2">Sales Trend</h3>
        <div>
          <SelectLabels
            valueKey="id"
            labelKey="key"
            text="Select Period"
            categoryData={period}
            onSelectChange={handleChange}
            previousValue={defaultNum}
          />
        </div>
      </div>
      {/* Replace with chart library like Chart.js */}
      <LineChart rawData={dataSet} />
    </div>
  );
}

export default DashboardSalesTrend;
